import copy from "copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { BiSolidCopyAlt } from "react-icons/bi";
import { toast } from "react-toastify";

// Create the prefix and suffix
const prefix = "$:var_";
const suffix = "!";

const CopyVariable = ({
  text,
  title,
  noTitle = false,
  ignoreLowerCase = false
}: {
  text: string;
  title?: string;
  noTitle?: boolean;
  ignoreLowerCase?: boolean;
}) => {
  const { t } = useTranslation();
  const textValue = title ? title + "_" + text : text;

  function cleanVariableKey(str: string) {
    if (!ignoreLowerCase) str = str.toLowerCase();

    const middlePart = str
      ?.trim()
      .replace(/[^\p{L}\p{N}]/gu, "_") // Replace non-alphanumeric with underscore
      .replace(/_+/g, "_") // Replace multiple consecutive underscores with single underscore
      .replace(/^_|_$/g, "");

    return middlePart;
  }

  function convertToVariableKey(str: string) {
    if (!str) return "";
    return prefix + cleanVariableKey(str) + suffix;
  }

  function displayVariable(srt: string) {
    return srt?.length > 30
      ? prefix + cleanVariableKey(srt?.slice(0, 30)) + "..." + suffix
      : convertToVariableKey(srt);
  }

  if (noTitle)
    return (
      <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
        <div
          className={`tw-w-full tw-h-11 tw-justify-between tw-items-center tw-gap-2 tw-flex tw-px-3 tw-py-2.5 tw-rounded-md tw-shadow tw-border tw-border-solid tw-border-gray-300`}
        >
          <div>
            {displayVariable(textValue) && (
              <div className="tw-px-3 tw-py-0.5 tw-bg-emerald-100 tw-rounded-xl tw-justify-center tw-items-center tw-inline-flex tw-h-max">
                <div className="tw-text-center tw-text-emerald-800 tw-text-sm tw-font-medium tw-font-['Inter'] tw-leading-tight tw-break-all">
                  {displayVariable(textValue)}
                </div>
              </div>
            )}
          </div>

          <button
            type="button"
            disabled={
              !textValue ||
              textValue.length === 0 ||
              (textValue.length === 1 && textValue === "_")
            }
            onClick={() => {
              copy(convertToVariableKey(textValue));

              toast.success(t("MacBotCreateVariableForm/key12"));
            }}
            className="tw-border-none tw-bg-transparent tw-text-gray-400 disabled:tw-cursor-not-allowed disabled:tw-text-gray-200"
          >
            <BiSolidCopyAlt className="tw-w-6 tw-h-6 tw-relative tw-cursor-pointer " />
          </button>
        </div>
      </div>
    );

  return (
    <div
      className={`tw-flex tw-flex-col tw-gap-2 tw-w-full tw-px-4 py-3 tw-bg-gray-100 tw-rounded-md tw-border tw-border-solid tw-border-gray-200`}
    >
      <div className="tw-text-gray-500 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
        {t("MacBotCreateVariableForm/key11")}
      </div>

      <div
        className={`tw-w-full tw-justify-between tw-items-center tw-gap-2 tw-flex`}
      >
        <div>
          {displayVariable(textValue) && (
            <div className="tw-px-3 tw-py-0.5 tw-bg-emerald-100 tw-rounded-xl tw-justify-center tw-items-center tw-inline-flex tw-h-max">
              <div className="tw-text-center tw-text-emerald-800 tw-text-sm tw-font-medium tw-font-['Inter'] tw-leading-tight tw-break-all">
                {displayVariable(textValue)}
              </div>
            </div>
          )}
        </div>

        <button
          type="button"
          disabled={
            !textValue ||
            textValue.length === 0 ||
            (textValue.length === 1 && textValue === "_")
          }
          onClick={() => {
            copy(convertToVariableKey(textValue));

            toast.success(t("MacBotCreateVariableForm/key12"));
          }}
          className="tw-border-none tw-bg-transparent tw-text-gray-800 disabled:tw-cursor-not-allowed disabled:tw-text-gray-200"
        >
          <BiSolidCopyAlt className="tw-w-6 tw-h-6 tw-relative tw-cursor-pointer " />
        </button>
      </div>
    </div>
  );
};

export default CopyVariable;
